import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/user/good_ico.png'
import _imports_1 from '@/assets/user/good_ico_on.png'
import _imports_2 from '@/assets/user/bad_ico.png'
import _imports_3 from '@/assets/user/bad_ico_on.png'
import _imports_4 from '@/assets/user/bo_arrow_l.png'
import _imports_5 from '@/assets/user/bo_arrow_r.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, "스트레스 케어", -1)
const _hoisted_5 = { class: "board_wrap bo_view_layer" }
const _hoisted_6 = { class: "bo_cate" }
const _hoisted_7 = { class: "bo_view" }
const _hoisted_8 = { class: "bo_view_tit" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "info" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, "|", -1)
const _hoisted_12 = { class: "bo_view_content" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 0,
  class: "bo_video"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "bo_gb_btns" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "off",
  alt: ""
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "on",
  alt: ""
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "off",
  alt: ""
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "on",
  alt: ""
}, null, -1)
const _hoisted_21 = { class: "bo_view_btns" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.category.list, (category) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: _normalizeClass($setup.state.selectCategoryIdx === category.idx ? 'active' : '')
                }, _toDisplayString(category.name), 3))
              }), 256))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", {
                  class: "tit",
                  innerHTML: $setup.content.title
                }, null, 8, _hoisted_9),
                _createElementVNode("span", _hoisted_10, [
                  _createTextVNode(_toDisplayString($setup.content.date) + " ", 1),
                  _hoisted_11,
                  _createTextVNode(" 조회수 : " + _toDisplayString($setup.numberFormat($setup.content.cntRead)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", {
                  style: {"margin-bottom":"20px"},
                  innerHTML: $setup.content.content
                }, null, 8, _hoisted_13),
                ($setup.content.youtubeLink && $setup.content.youtubeLink !== '' && $setup.content.youtubeLink !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("iframe", {
                        width: "100%",
                        height: "100%",
                        src: $setup.content.youtubeLink,
                        frameborder: "0",
                        allowfullscreen: ""
                      }, null, 8, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["good_btn", $setup.state.isLike === true ? 'active' : '']),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.pushLike && $setup.pushLike(...args)))
                }, [
                  _hoisted_17,
                  _hoisted_18,
                  _createElementVNode("span", null, "좋아요 [" + _toDisplayString($setup.content.cntLike) + "]", 1)
                ], 2),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["bad_btn", $setup.state.isBad === true ? 'active' : '']),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.pushBad && $setup.pushBad(...args)))
                }, [
                  _hoisted_19,
                  _hoisted_20,
                  _createElementVNode("span", null, "싫어요 [" + _toDisplayString($setup.content.cntBad) + "]", 1)
                ], 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              ($setup.content.prevIdx !== null)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "#",
                    class: "prev",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goDetail($setup.content.prevIdx)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22,
                      _createTextVNode(" 이전 글 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                to: "#",
                class: "list",
                onClick: $setup.backToList
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 목록 ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              ($setup.content.nextIdx !== null)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: "#",
                    class: "next",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.goDetail($setup.content.nextIdx)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 다음 글 "),
                      _hoisted_23
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "content", "onClose"])
  ], 64))
}